module.exports = __webpack_public_path__ + "img/house_battery_on.8c90593e.png";